import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { SHARED_SERVICE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerGroupingClient {
  static baseUrl = SHARED_SERVICE_URL;

  static dealerSearch(
    selectedMarket,
    user,
    dealerGroupId,
    page,
    isFieldUser = false
  ) {
    let url = `${this.baseUrl}/dealer-search`;

    if (selectedMarket) {
      url += "?selectedMarket=" + selectedMarket;
    }

    if (dealerGroupId) {
      url += "&dealerGroupId=" + dealerGroupId;
    }

    if (isFieldUser) {
      url += "&isFieldUser=true";
    }

    if (page) {
      url += "?page=" + page;
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data.result;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static getDealerGroup(
    user,
    market = null,
    isSuperGroupUser,
    dealerGroupId,
    page,
    isFieldUser = false
  ) {
    let resourcePath = user.generateResourcePath();
    if (dealerGroupId) {
      resourcePath = `dealer/${dealerGroupId}`;
    }
    let url = `${this.baseUrl}/${resourcePath}/dealer-group`;

    if (isFieldUser) {
      url += "&isFieldUser=true";
    }

    if (page) {
      url += "?page=" + page;
    }

    if (market !== null) {
      url += "?selectedMarket=" + user.market;
    }

    if (isSuperGroupUser) {
      url += "&isSuperGroupUser=true";
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data.result.dealerGroupings;
      })
      .catch((error) => {
        const isNsc = user.userType === "nsc";
        const isPo = user.userType === "po";

        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        } else if (!(isNsc || isPo)) {
          user.history.push("/error");
        }

        return Promise.reject(error);
      });
  }
}
